import { catchError, EMPTY, mergeMap } from "rxjs"
import { ACTION_TYPES } from "../actions/types"
import { ofType } from "redux-observable"
import { Service } from "../services/service"
import { Action } from "../actions/actions"
import { InventoryConfigurationSelector } from "../selectors"
import { InventoryConfigurationAction } from "../actions"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"

export const fetchEpic = (action$) => {
    return action$.pipe(
        ofType(ACTION_TYPES.FETCH),
        mergeMap(() => {
            return Service.fetch()
                .then(response => {
                    return Action.fetchSuccess(response)
                })
        }),
        catchError(() => EMPTY)
    )
}

export const patchEpic = (action$, $state) => {
    return action$.pipe(
        ofType(ACTION_TYPES.PATCH),
        mergeMap(() => {
            const config = InventoryConfigurationSelector.get($state.value)
            return Service.patch(config.id, config)
                .then(res => {
                    AppContext.inventoryConfiguration = res
                    return InventoryConfigurationAction.fetchSuccess(res)
                })
        }),
        catchError(() => EMPTY)
    )
}




// WEBPACK FOOTER //
// ./src/state/inventory/configuration/epics/epics.ts